














































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import MarkdownIt from 'markdown-it';
// eslint-disable-next-line no-unused-vars
import Timeline from '@/models/Timeline';
// eslint-disable-next-line no-unused-vars
import Node from '@/models/Node';
import Mutations from '@/store/mutations';
import KeyListener from '@/KeyListener';

@Component({
    computed: {
        ...mapGetters([
            
        ])
    },
    recomputed: {
        
    }
})
export default class MiniEventSlide extends Vue 
{
    @Prop(Number) readonly nodeid! : Number;

    forceUpdateImgUrl = false;

    md = new MarkdownIt();

    get event() : Node
    {
        return this.$store.getters.nodes.get(this.nodeid);
    }

    get timeline() : Timeline
    {
        return this.$store.state.project.activeTimeline;
    }

    get isNodeImageValid() 
    {
        return this.event.image.trim() != '';
    }

    get loadedImage() 
    {
        console.log("LOADING");
        let img = new Image();
        img.src = this.rawImageUrl;
        if (!img.complete)
        {
            console.log("Image not cached");
            img.onload = () =>
            {
                console.log('Image fully loaded');
                this.forceUpdateImgUrl = !this.forceUpdateImgUrl;
            };
        }
        return img;
    }

    get rawImageUrl()
    {
        if (this.event.image.trim() == '')
        {
            return '/images/placeholder_img.png';
        }
        return this.event.image;
    }

    get isImageLoaded()
    {
        if (this.forceUpdateImgUrl && !this.forceUpdateImgUrl)
        {
            console.log('update!');
        }
        return this.loadedImage.complete;
    }

    get imageUrl()
    {
        this.forceUpdateImgUrl;
        let rawURL = this.rawImageUrl;
        return rawURL;
    }

    mounted()
    {
        KeyListener.addKeyHandler(this);
       	setTimeout(() => 
        {
            this.$nextTick(() =>
            {
                (this.$refs.eventName as HTMLElement).focus();
            });
        }, 50);
    }

    beforeDestroy()
    {
        KeyListener.removeKeyHandler(this);
    }

    keyHandler(_event : Event, isTextBoxFocused : boolean)
    {
        if (!isTextBoxFocused)
        {
            if (KeyListener.isPeriodDown())
            {
                this.next();
            }
            else if (KeyListener.isCommaDown())
            {
                this.previous();
            }
        }
    }
    
    previous()
    {
        // get the previous nodeid from timeline.getEventOrdering(), close this, open that one
        this.close();
        let ordering = this.timeline.getEventOrdering();
        let index = ordering.indexOf(this.event.nodeid);
        index = ((index - 1) >= 0) ? (index - 1) : ordering.length - 1;
        let n = this.$store.getters.nodes.get(ordering[index]);
        if (n != null && n.component != null)
        {
            n.component.onNodeClick(null, true);
        }
    }

    expand()
    {
        // close this, open equivalent FullEventSlide
        this.close();
        this.$store.commit(Mutations.setPresentationFullSlide, this.nodeid);
    }

    next()
    {
        // get the next nodeid from timeline.getEventOrdering(), close this, open that one
        this.close();
        let ordering = this.timeline.getEventOrdering();
        let index = ordering.indexOf(this.event.nodeid);
        index = ((index + 1) < ordering.length) ? (index + 1) : 0;
        let n = this.$store.getters.nodes.get(ordering[index]);
        
        // TODO: This currently fails if the other node is offscreen due to the culling logic.
        // We should fix that.
        if (n != null && n.component != null)
        {
            n.component.onNodeClick(null, true);
        }
    }

    close()
    {
        this.event.component.onNodeClick();
    }

    renderMarkdown(text: string)
    {
        return this.md.render(text
            // pre-process
            .replace(/\<(?!\w*\:\/\/)([^\s]+\.[^\s]+)\>/g, '<https://$1>') // all links are absolute
        )
            // post-process
            .replace(/<a[ >]/g, '<a target="_blank" ') // all links target new tab/window
            .replace(/href="((?!\w+\:\/\/)[^"]+)"/g, 'href="https://$1"') // all links are absolute
            .replace(/<img[ >]/g, '<img style="max-width: 80%; max-height: 200vh; object-fit: contains;" '); // resize images
    }
}
